import api from 'core/api';

// eslint-disable-next-line import/prefer-default-export
export const languages = () => api.get(`/languages`);
